import { css } from 'styled-components';
import { variables } from '@generationtux/component-library';

const globalStyle = css`
  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  html {
    background-color: ${props => variables(props).grayLighter};
  }

  p,
  li {
    font-family: ${props => variables(props).fontBody};
    line-height: ${props => variables(props).fontBaseLineHeight};
  }

  img {
    display: inline-block;
    max-width: 100%;
    height: auto;
  }

  .lozad-picture-img-block img {
    display: block;
  }

  @font-face {
    font-family: 'DomD Reg';
    font-display: swap;
    src: url('/fonts/DomDWeb-Regular.eot'); /* IE9 Compat Modes */
    src: url('/fonts/DomDWeb-Regular.woff2') format('woff2'),
      /* Super Modern Browsers */ url('/fonts/DomDWeb-Regular.woff') format('woff'); /* Pretty Modern Browsers */
    font-style: normal;
  }

`;
export default globalStyle;
